import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import {
    MasterAdminIcon,
    MonitorPerfIcon,
    PaymentGateIcon,
    FeatureRollIcon,
    CustomerAnalyIcon,
    AccessSetIcon,
} from "../../../../app-constants"

const Robustsolution = () => {
    return (
        <div className="robust_solution p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Run All Ecommerce Transactions & Manage Payments Through Our Advanced Backend Features</h2>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {MasterAdminIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Master Admin Panel</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>This incredible control panel will help you streamline your E-commerce app’s operations by assisting you in controlling all the features of the app from a single place.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {MonitorPerfIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Monitor Performance</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>Know where customers show the most interest in your ecommerce app and optimize them through attaining real time performance reports for each part of the app.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {PaymentGateIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Payment Gateway</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>A platform where all of the payments made via the app are easily visible. You can add or redact new payment methods as per your requirements with incredible ease through our streamlined payment gateway.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {FeatureRollIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>App Installation & Updates </h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>Run new updates or roll out new features through a unified platform to keep your app updated and in line with customer preferences.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {CustomerAnalyIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Customer Analytics</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>Know how customers are reacting and interacting with each part of your app and lead the initiative towards bringing in constant improvement through informed data analytics.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <div className="robust_sol_main">
                            <div className="robust_sol_box">
                                <div className="robust_sol_img">
                                    {AccessSetIcon}
                                </div>
                                <div className="robust_sol_head">
                                    <h5>Access Settings</h5>
                                </div>
                            </div>
                            <div className="robust_sol_content">
                                <p>Restrict or provide access to various parts of the app to either the customers or your team members, thereby firmly remaining in control of your app.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Robustsolution